import { ESInterface } from "src/compentsModus/ESInterface";
import { VersionedObjectPersistence } from "src/common/managers/ESVersionedPersistance";
import { PLADataService, PLAElementRecord, PLAProject, PLAProjectService, PLARecord, PLARelationRecord } from "./PLAState";

export class PLAProjectPersistence extends VersionedObjectPersistence<PLAProject> {
   private static idGetter = (object: PLAProject) => object.id;

   constructor(objectsESIndexName: string, userId: string) {
      super(objectsESIndexName, userId, {}, PLAProjectPersistence.idGetter);
   }
}

export class PLARecordPersistence extends VersionedObjectPersistence<PLARecord> {
   public static indexMappings = {
      properties: {
         recordType: { type: "keyword" },
         id: { type: "keyword" },
         elementType: { type: "keyword" },
         relationType: { type: "keyword" },
         fromId: { type: "keyword" },
         toId: { type: "keyword" },
         geoPoint: { type: "geo_point" },
         geoShape: { type: "geo_shape" },
         viamapUserId: { type: "keyword" },
         lastChangedTimestamp: { type: "date" }
      }
   };
   private static idGetter = (object: PLARecord) => object.id;

   constructor(objectsESIndexName: string, userId: string) {
      super(objectsESIndexName, userId, PLARecordPersistence.indexMappings, PLARecordPersistence.idGetter);
   }
}

export class PLAProjectServiceImpl implements PLAProjectService {
   private persistence: PLAProjectPersistence;

   constructor(projectsElasticIndex: string, userId: string) {
      this.persistence = new PLAProjectPersistence(projectsElasticIndex, userId);
   }

   loadProjects(): Promise<PLAProject[]> {
      return this.persistence.listObjects();
   }

   saveProject(project: PLAProject): Promise<void> {
      return this.persistence.saveObject(project);
   }

   deleteProject(projectId: string): Promise<void> {
      return this.persistence.deleteObject(projectId);
   }

   async createProject(project: PLAProject): Promise<void> {
      await this.saveProject(project);
      const es = new ESInterface(this.persistence.esIndexName);
      await es.createIndex(project.esIndexName, { mappings: { ...PLARecordPersistence.indexMappings, _meta: { CreatedBy: this.persistence.userId } } });
   }
}

export class PLADataServiceImpl implements PLADataService {
   private persistence: PLARecordPersistence;

   constructor(index: string, userId: string) {
      this.persistence = new PLARecordPersistence(index, userId);
   }

   async loadElements(): Promise<PLAElementRecord[]> {
      const records = await this.persistence.listObjects();
      return records.filter((record): record is PLAElementRecord => record.recordType === "ELEMENT");
   }

   async loadRelations(): Promise<PLARelationRecord[]> {
      const records = await this.persistence.listObjects();
      return records.filter((record): record is PLARelationRecord => record.recordType === "RELATION");
   }

   saveElement(element: PLAElementRecord): Promise<void> {
      return this.persistence.saveObject(element);
   }

   saveRelation(relation: PLARelationRecord): Promise<void> {
      return this.persistence.saveObject(relation);
   }

   deleteElement(elementId: string): Promise<void> {
      return this.persistence.deleteObject(elementId);
   }

   deleteRelation(relationId: string): Promise<void> {
      return this.persistence.deleteObject(relationId);
   }
}
